import {WarningTheme} from 'common/components/warning/constants';
import {REPORT_BASICS_LINKS, ReportName} from 'common/report/constants';

export enum WarningTrackingError {
  MissingMappedDatagroup = `missing-mapped-datagroup`,
  UnsupportedActionError = `unsupported-action`,
}

enum ExtraTheme {
  EmptyReport = `empty-report`,
}

export const WarningHeroTheme = {...WarningTheme, ...ExtraTheme};
export type WarningHeroTheme = WarningTheme | ExtraTheme;

export const WarningHeroReportName = {
  Dashboards: ReportName.Dashboards,
  Insights: ReportName.Insights,
  Impact: ReportName.Impact,
  Inspector: ReportName.Inspector,
  Retention: ReportName.Retention,
  Funnels: ReportName.Funnels,
  Flows: ReportName.Flows,
  ExperimentReporting: ReportName.ExperimentReporting,
  Signal: ReportName.Signal,
  LookupTables: `lookup-tables`,
  PublicDashboards: `public-dashboards`,
} as const;

export type WarningHeroReportName = typeof WarningHeroReportName[keyof typeof WarningHeroReportName];

export const WARNING_HERO_BASICS_LINKS = {
  ...REPORT_BASICS_LINKS,
  [WarningHeroReportName.LookupTables]: `https://help.mixpanel.com/hc/en-us/articles/360044139291-Lookup-tables`,
};

export const EXAMPLE_LINKS: Partial<{[key in WarningHeroReportName]: string}> = {
  [WarningHeroReportName.Dashboards]: `/report/2195193/view/139237/dashboards#id=685944`,
  [WarningHeroReportName.Insights]: `/report/2195193/view/139237/dashboards#id=904329`,
  [WarningHeroReportName.Retention]: `/report/2195193/view/139237/dashboards#id=904336`,
  [WarningHeroReportName.Funnels]: `/report/2195193/view/139237/dashboards#id=904332`,
  [WarningHeroReportName.Flows]: `/report/2195193/view/139237/flows/#report/11673124`,
  [WarningHeroReportName.LookupTables]: `https://www.youtube.com/watch?v=pzWpCH4jvJQ`,
};

export enum NoDataReason {
  Default = `default`,
  EmptyProject = `empty-project`,
  Timeout = `timeout`,
}

export const EMPTY_REPORT_HEADER = {
  [WarningHeroReportName.Dashboards]: `Add a report to your board.`,
  [WarningHeroReportName.Insights]: `Select an Event or Cohort to get started.`,
  [WarningHeroReportName.Flows]: `Select at least one step to begin a flow.`,
  [WarningHeroReportName.Funnels]: `Select two funnel steps to get started.`,
  [WarningHeroReportName.Retention]: `Select two events to get started.`,
  [WarningHeroReportName.Impact]: `Select a launch event and the events you'll use to measure its impact.`,
  [WarningHeroReportName.ExperimentReporting]: `Select an experiment and two variant groups to get started.`,
  [WarningHeroReportName.LookupTables]: `Import a lookup table to enrich properties with extra data.`,
  [WarningHeroReportName.PublicDashboards]: `This dashboard is empty.`,
  [WarningHeroReportName.Signal]: `Enter your question to discover actions correlated with your goal.`,
};
